import { BrowserRouter, Routes, Route } from "react-router-dom";
import { NextUIProvider } from "@nextui-org/react";
import Nav from "./Navbar";
import MobileNavbar from "./Navbar/mobile";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Blog from "./pages/Blog";
import BlogPost from "./pages/Blog/BlogPost";
import About from "./pages/About";
// import Contact from "./pages/Contact";
import Work from "./pages/Work";

function App() {
  const routes = [
    { path: "/", element: <Home /> },
    { path: "/blog", element: <Blog /> },
    { path: "/blog/:slug", element: <BlogPost /> },
    { path: "/about", element: <About /> },
    // { path: "/contact", element: <Contact /> },
    { path: "/work", element: <Work /> },
  ];
  return (
    <NextUIProvider>
      <BrowserRouter>
        <div className="flex min-h-screen flex-col font-sans">
          <Nav></Nav>
          <MobileNavbar></MobileNavbar>
          <main className="flex-1">
            <Routes>
              {routes.map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={route.element}
                  />
                );
              })}
            </Routes>
          </main>
          <Footer></Footer>
        </div>
      </BrowserRouter>
    </NextUIProvider>
  );
}

export default App;
